export default () => ({
  title: "",
  serviceGroups:[],
  activeServiceGroups:[],
  serviceGroup:null,
  serviceGroupsToEdit: '',
  status: '',
  total: '',
});
